module.exports = __webpack_public_path__ + "../resources/img/bg_pv1_01.d66ca67f.png";